<template>
  <div class="home-page">
    <nav-bar @open-auth="onOpenAuth" />
    <home-hero />
    <home-features />
    <home-products />
    <home-news />
    <home-notice />
    <site-footer />
    <auth-modal ref="authModal" @login-success="onLoginSuccess" />
  </div>
</template>

<script>
import NavBar from '@/components/NavBar'
import AuthModal from '@/components/AuthModal'
import SiteFooter from '@/components/SiteFooter'
import HomeHero from './home/HomeHero'
import HomeFeatures from './home/HomeFeatures'
import HomeProducts from './home/HomeProducts'
import HomeNews from './home/HomeNews'
import HomeNotice from './home/HomeNotice'

export default {
  name: 'home',
  components: {
    NavBar, AuthModal, SiteFooter,
    HomeHero, HomeFeatures, HomeProducts, HomeNews, HomeNotice
  },
  methods: {
    onOpenAuth (type) {
      this.$refs.authModal.open(type === 'register' ? 'register' : 'login')
    },
    onLoginSuccess () {
      this.$router.go(0)
    }
  }
}
</script>

<style lang="less" scoped>
@import '~@/assets/styles/variables.less';
.home-page {
  background: @bg-page;
  min-height: 100vh;
}
</style>
